module.exports = __webpack_public_path__ + "static/infringement-issues-trademark-0e354e49981ee1855892cd8879c2a994.png";